import { render } from "./viajes.vue?vue&type=template&id=d4f605d0&scoped=true"
import script from "./viajes.vue?vue&type=script&lang=js"
export * from "./viajes.vue?vue&type=script&lang=js"

import "./viajes.vue?vue&type=style&index=0&id=d4f605d0&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f605d0"]])

export default __exports__